<template>
    <div>
      <div id="loadingToast" v-show="isShowLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">{{loadingText}}</p>
        </div>
      </div>
    </div>
</template>
<style>
</style>
<script>
  export default {
    name: 'loading',

    computed: {
      isShowLoading () {
        return this.$store.getters.getIsShowLoading
      },

      loadingText () {
        return this.$store.getters.getLoadingText
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Loading.vue?5aa5778e